/** @jsxImportSource @emotion/react */
import { useState, BaseSyntheticEvent} from "react";
import { useForm, SubmitHandler, Controller } from "react-hook-form";
import { getToken, TokenResponse } from "../../common/Util";
import { RequireValidateion} from "../../common/Validation";
import * as Yup from "yup";
import { yupResolver } from '@hookform/resolvers/yup';
import { useNavigate } from "react-router-dom";
import { CircularProgress } from "@mui/material";
import logincss from "../../css/login.module.css";
import { use100vh } from "react-div-100vh";

type IFormInputs = {
    userid: string,
    password: string,
}

type LoginProp = {
    loginMessage: string,
}

export const Login = (prop: LoginProp) => {
    const height = use100vh();
    const navigate = useNavigate();

    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [loginResultMessage, setLoginResultMessage] = useState<string>(prop.loginMessage);

    const schema = Yup.object({
        userid: RequireValidateion,
        password: RequireValidateion,
    });

    const { register, handleSubmit, trigger, control, getValues, watch, formState: { errors, isValid }, setValue, reset } = useForm<IFormInputs>({
        defaultValues: {
            userid: "",
            password: "",
        },
        resolver: yupResolver(schema),
        mode: "onSubmit",
        reValidateMode: "onSubmit",
    });

    const onSubmit: SubmitHandler<IFormInputs> = async (data: IFormInputs, event?: BaseSyntheticEvent) => {
        setLoginResultMessage((value) => {return ""});
        setIsLoading((value) => {return true});
        await getToken<TokenResponse>(data.userid, data.password)
        .then(response => {
            localStorage.setItem('accesstoken', response.data.access);
            localStorage.setItem('refreshtoken', response.data.refresh);
            window.location.reload();
            //JumpPage(RouterUrl.Upload, {}, navigate);
        })
        .catch((e) => {
            setLoginResultMessage((value) => {return "ログインに失敗しました。"});
        })
        .finally(() => {
            setIsLoading((value) => {return false});
        });
    }

    return(
        <>
        <div className={logincss['basebody']}>
        <div id={logincss['wraper']}>
            <div id={logincss['formContener']}>
                <h1 className={logincss['cht-icon']}></h1>
                <div id={logincss['imputArea']}>
                    <div>{isLoading}</div>
                    <form onSubmit={(e) => { handleSubmit(onSubmit)(e) }}>
                        <div className={logincss['imputBox']}>
                            <div className={logincss['imputName']}>
                                <h3>ユーザ名</h3>
                            </div>
                            <Controller
                                name="userid"
                                control={control}
                                render={({field}) => (
                                    <input type="text" {...field} {...register('userid')}></input>
                                )}
                            />
                            <div className={logincss['error']}>{errors.userid?.message}</div>
                        </div>
                        <div className={logincss['imputBox']}>
                            <div className={logincss['imputName']}>
                                <h3>パスワード</h3>
                            </div>
                            <Controller
                                name="password"
                                control={control}
                                render={({field}) => (
                                    <input type="password" {...field} {...register('password')}></input>
                                )}
                            />
                            <div className={logincss['error']}>{errors.password?.message}</div>
                        </div>
                        <div className={logincss['imputBtn']}>
                            {
                                isLoading ?
                                <CircularProgress></CircularProgress>
                                :
                                <input type="submit" value="ログイン" disabled={isLoading} onClick={(e) => {
                                    setLoginResultMessage((value) => {return ""});
                                }}></input>
                            }
                        </div>
                        <div className={logincss['imputBox']}>
                            <div className={logincss['error']}>{loginResultMessage}</div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        </div>
        </>
    );
}